import loc from 'owa-localize';
import { lazySetTriageActionAnnouncement } from 'owa-mail-store';
import FlagStatus from 'owa-service/lib/contract/FlagStatus';
import {
    conversationFlaggedAnnouncement,
    conversationUnflaggedAnnouncement,
    itemFlaggedAnnouncement,
    itemUnflaggedAnnouncement,
} from './announceFlaggedStatus.locstring.json';

/**
 * This function sets the message for the MailModule's Announced component
 * so that the status of the flagged operation the user did is read by their
 * screen reader.
 */
export default function announceFlaggedStatus(
    flagStatus: FlagStatus,
    isConversation: boolean
): void {
    if (flagStatus === 'Flagged') {
        lazySetTriageActionAnnouncement.importAndExecute(
            isConversation ? loc(conversationFlaggedAnnouncement) : loc(itemFlaggedAnnouncement)
        );
    } else if (flagStatus === 'NotFlagged') {
        lazySetTriageActionAnnouncement.importAndExecute(
            isConversation ? loc(conversationUnflaggedAnnouncement) : loc(itemUnflaggedAnnouncement)
        );
    }
}
